import styled from 'styled-components';

const Link = styled.a`
  color: ${({ theme }) => theme.accent.primary};
  text-decoration: none;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: ${({ theme }) => theme.accent.secondary};
  }

  &:active {
    color: ${({ theme }) => theme.text};
    outline: none;
  }

  &:focus {
    outline: none;
  }
`;

export default Link;
